import React, { Component } from 'react';
import './Header.css';

class Header extends Component {
  render() {
    return (
        <div className='header'>
          <img alt="Header background" src="../../images/background.jpg" style={{"visibility" : "hidden"}} />
          <div className = 'call-us'>
            Call Us: 512.534.5097
          </div>
          <div className='business-name'>
            KerBob
          </div>
          <div className='business-tagline'>
            We connect people...<span className='italic'>and things</span>
          </div>
        </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header/Header.js